import { render, staticRenderFns } from "./ModalInvestQuantity.vue?vue&type=template&id=415f3a7a&scoped=true"
import script from "./ModalInvestQuantity.vue?vue&type=script&lang=js"
export * from "./ModalInvestQuantity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415f3a7a",
  null
  
)

export default component.exports